export enum StrapiIcons {
  MUSIC_SCORE = 'music_score',
  PACKAGE = 'package',
  CHECKMARK = 'checkmark',
  GIFT = 'gift',
  DISC = 'disk',
  ZAP = 'zap',
  CALENDAR_OUTLINED = 'calendar_outlined'
}
